
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import PostLayout from "@src/layouts/PostLayout";
import BorderBox from "@src/components/BorderBox";
import ListBox from "@src/components/ListBox";
import GoogleMap from "@src/components/GoogleMap";
import InstaImage from "@src/components/InstaImage";
import { murakamiMasanori } from "@src/constants/authors";
import { harajukuChavatyChavatyTopImage } from "@src/constants/images";
export const meta = {
  path: "/media/harajuku/chavaty",
  title: "【表参道カフェ】紅茶専門店CHAVATY(チャバティー)のお得なメニューを公開！",
  description: "表参道の紅茶専門店CHAVATY(チャバティー)についてまとめました！特に、隠れメニュー、行列情報、支払い方法など、調べても中々でてこないような情報も掲載しています！CHAVATY(チャバティー)に行く際は、メニューなど事前にお得情報を調べていってみてください！",
  topImg: harajukuChavatyChavatyTopImage,
  author: murakamiMasanori,
  tags: ["有名店", "おしゃれな内装", "スイーツ", "人気店", "お店の紹介", "紅茶", "デート", "女子会"]
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Text = makeShortcode("Text");
const layoutProps = {
  meta
};
const MDXLayout = ({ children }) => (
  <PostLayout meta={meta}>{children}</PostLayout>
)
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`表参道の紅茶専門店 CHAVATY(チャバティー)についてまとめました！`}</p>
    <p>{`隠れメニューが CHAVATY(チャバティー)にはある？行列や待ち時間ってどれくらい？支払いって電子マネーやクレカ使えるの？といった、他のサイトでは調べても中々でてこないような情報を中心にご紹介させていただいております！`}</p>
    <p>{`紅茶専門店の CHAVATY(チャバティー)でティーやスイーツを楽しんでもらうためにも、事前にチェックしてみてください…！`}</p>
    <h2>{`チャバティーとは？`}</h2>
    <InstaImage postId="B-TwBNZlte4" mdxType="InstaImage" />
    <InstaImage postId="B9WlrPmgH75" mdxType="InstaImage" />
    <p>{`紅茶専門店のカフェとして 2018 年 7 月にオープンし、流行に敏感な若い女性がいつも行列を作っている表参道人気のカフェ
紅茶の葉っぱを、インドの下にある`}<strong parentName="p">{`スリランカ`}</strong>{`という国から、`}<strong parentName="p">{`茶葉の特徴が最も出る時期の`}</strong>{`ものを仕入れているそうです。
若い新鮮な紅茶の香りと風味が楽しめる紅茶になっています。`}</p>
    <h2>{`メニュー`}</h2>
    <p>{`チャバティーには紅茶などの茶葉を使ったドリンク、スイーツを含めて、豊富なカフェメニューが取り揃えられています。
隠れメニューもありますので、そちらも合わせてご紹介させていただきます！`}</p>
    <h3>{`ティーラテ(税込：638 円)`}</h3>
    <InstaImage postId="B3EAdgGFh4o" mdxType="InstaImage" />
    <p><strong parentName="p">{`ミルク、抹茶、ほうじ茶`}</strong>{`の３種類から選べるようになっています！
アイスティーラテは牛乳瓶のようにガラスの瓶に入ってでてくるが、おしゃれですよね…！`}</p>
    <p><strong parentName="p">{`ホットティーラテ`}</strong>{`はこんなにふわふわに…！`}</p>
    <InstaImage postId="Bnh5wFggGAO" mdxType="InstaImage" />
    <InstaImage postId="BpnmI6tl9hG" mdxType="InstaImage" />
    <p>{`ホットラテは、アイスラテと`}<strong parentName="p">{`値段は一緒`}</strong>{`の(税込：638 円)円になります。
温かいラテがお好みの方は、こちらのふわふわのホットラテを、お好きな茶葉を選んで召し上がってください！`}</p>
    <h3>{`お得なメニュー | 紅茶とスコーンのセット(935 円)`}</h3>
    <p>{`「紅茶だけ飲む」「スコーンだけ食べる」ではなく、チャバティー(CHAVATY)にせっかく来たからどちらも楽しみたい！という方も多いのではないでしょうか。
紅茶とスコーンのセット(税込：935 円)は、３種類の紅茶から好きなティー１つ選ぶことができ、
チャバティー自家製のスコーンが２個食べられるお得なセットになっています！`}</p>
    <InstaImage postId="B-XGbfSHlAY" mdxType="InstaImage" />
    <p>{`スコーンには、塩ホイップクリームやハニーナッツをかけて食べると、
いろんな風味が楽しめるような形になっています！`}</p>
    <h3>{`テイクアウトで人気 | ソフトクリーム(税込：528 円)`}</h3>
    <InstaImage postId="B7Noul_pNAX" mdxType="InstaImage" />
    <InstaImage postId="B5CFTfWHkvD" mdxType="InstaImage" />
    <p>{`３種類の茶葉を練り込んだ、きめ細かい粒子が写真からも分かる濃厚アイスクリーム！
甘すぎず、すっきりとした味わいにも濃厚な風味漂うソフトクリームになっています！`}</p>
    <h3>{`隠れメニュー | モーニングメニュー(税込：1,298 円)`}</h3>
    <p>{`2020 年 2 月 16 日（日）から始まり、第 3 日曜日だけ実施しているモーニングメニュー。
こちらのモーニングメニューは、なんと`}<strong parentName="p">{`予約限定`}</strong>{`のみになっているそうなので、
もし行きたい方は電話で予約をしてみてください…！`}</p>
    <InstaImage postId="B8oSrz6A1MT" mdxType="InstaImage" />
    <p>{`メニューはこんな感じになっているそうです！`}</p>
    <ListBox list={["目覚めのアイスウバストレートティ", "モーニングサラダ", "オリジナルスコーン〜ハニーナッツ・塩ホイップバターをつけて〜", "MAIN（焼きたて自家製抹茶のクロワッサン/はちみつをたっぷりとかけた自家製グラノーラのヨーグルトボウル)", "DRINK（ホットティーラテ（ウバ / 抹茶 / ほうじ茶))"]} mdxType="ListBox" />
    <hr></hr>
    <h2>{`アクセス`}</h2>
    <p>{`表参道駅 A2 出口より徒歩 5 分、明治神宮前駅から徒歩 10 分
「幸せのパンケーキ 表参道」や「パンとエスプレッソと」と同じ通りに位置しています！
賑わっているエリアで、都会的な雰囲気の建物が見つけてください！`}</p>
    <InstaImage postId="B-12JBBAzFI" mdxType="InstaImage" />
    <GoogleMap lat={35.6682121} lng={139.7116368} mdxType="GoogleMap" />
    <hr></hr>
    <h2>{`行列情報`}</h2>
    <BorderBox mdxType="BorderBox">
  <Text as="p" mdxType="Text">
    <Text as="span" fontWeight="bold" mdxType="Text">
      営業時間：10:00~20:00
    </Text>
    <Text as="span" fontWeight="bold" mdxType="Text">
      行列時間：13:00~17:00(日の異なる場合あり)
    </Text>
  </Text>
    </BorderBox>
    <p>{`テイクアウトの場合で行列ができていると待ち時間は 30~60 分程度で、カフェ待ちだと回転率は早くないので 60~120 分程度待つこともあると思います！
タイミングを合わせるのは難しいと思いますが、空いている時間帯を狙っていくと、ストレスなく入れると思います！`}</p>
    <h2>{`支払い方法`}</h2>
    <p>{`チャバティーではクレカや電子マネーが使えるので、キャッシュレスで支払えるのは便利ですよね…！
原宿・表参道エリアでも中々キャッシュレスに対応していないところが多いので、ありがたい！`}</p>
    <BorderBox mdxType="BorderBox">
  <Text as="p" mdxType="Text">
    <Text as="span" fontWeight="bold" mdxType="Text">
      電子マネー：○(paypay)
    </Text>
    <Text as="span" fontWeight="bold" mdxType="Text">
      クレカ：○
    </Text>
    <Text as="span" fontWeight="bold" mdxType="Text">
      現金：○
    </Text>
  </Text>
    </BorderBox>
    <hr></hr>
    <h3>{`おわりに`}</h3>
    <p>{`紅茶専門店の CHAVATY(チャバティー)についてご紹介してきましたが、いかがでしたか？
お得な情報が少しでも役立てればと思っているので、また記事を確認して素敵なティータイムをお過ごしください！`}</p>

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;